import styled from "@emotion/styled";
import {
  grayScale,
  mBody1,
  mBody3,
  mBody4,
  mTitle1,
  sparta,
} from "@teamsparta/design-system";

export const Gap = styled.div`
  height: ${(props) => props.size}px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Badge = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 12px;
  gap: 10px;

  width: fit-content;
  height: 28px;

  background: #ff6c7a;
  border-radius: 17px;

  ${mBody3};
  color: ${grayScale.white};
`;

export const SubTitle = styled.div`
  text-align: left;
  ${mTitle1};
  color: ${sparta.red75};
`;

export const Title = styled.div`
  font-family: "Cafe24Ohsquare";
  font-style: normal;
  font-weight: 700;
  font-size: 25px;
  line-height: 140%;

  letter-spacing: -0.02em;

  color: ${grayScale.gray100};
  text-align: left;

  span {
    color: ${sparta.red100};
  }
`;

export const BenefitImg = styled.img`
  width: 328px;
`;

export const Cta = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 20px 0px;
  gap: 4px;

  width: fit-content;
  width: 180px;
  height: 44px;

  background: #e8344e;
  border-radius: 100px;
  cursor: pointer;

  align-self: center;

  ${mBody1}
  color: ${grayScale.white};
`;

export const NoticeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  gap: 8px;

  width: 336px;

  background: #ffffff;
  border-radius: 12px;

  ${mBody4};
  font-weight: 500;
  color: ${sparta.red100};
  text-align: left;
`;
